/** Broadcast when flag bag status is persisted (local queue or server). FlagBagList listens to refresh. */
export const FLAGBAG_STATUS_SAVED_EVENT = "flagbag-status-saved";

export function dispatchFlagBagStatusSaved(): void {
	if (typeof window === "undefined") return;
	window.dispatchEvent(new CustomEvent(FLAGBAG_STATUS_SAVED_EVENT));
}
